<script setup lang="ts">
import type { ShowcaseContentListItemDto } from '@repo/api/web/models'
import { useIntersectionObserver } from '@vueuse/core'

import ContentCard from '../Card/ContentCard.vue'

const props = defineProps<{
  items: ShowcaseContentListItemDto[]
  pending?: boolean
  /** Базовый путь детальных страниц ('/news', '/blog') */
  basePath: string
  emptyText: string
  /** href краулябельной ссылки «Следующая страница» */
  nextHref?: string
}>()

const emit = defineEmits<{
  loadMore: []
}>()

const sentinel = useTemplateRef('sentinel')
useIntersectionObserver(sentinel, ([entry]) => {
  if (entry?.isIntersecting) emit('loadMore')
})
</script>

<template>
  <div>
    <p v-if="!props.pending && !props.items.length" class="text-neutral-500">
      {{ props.emptyText }}
    </p>

    <div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      <ContentCard
        v-for="item in props.items"
        :key="item.slug"
        :value="item"
        :base-path="props.basePath"
      />
    </div>

    <div ref="sentinel" class="h-px" />

    <div v-if="props.nextHref" class="mt-8 flex justify-center">
      <a
        :href="props.nextHref"
        rel="next"
        class="rounded-full border border-neutral-300 px-6 py-2 text-sm"
      >
        Следующая страница
      </a>
    </div>
  </div>
</template>
